import { render } from "./RuiMenuClose.vue?vue&type=template&id=a49a34ae"
const script = {}
script.render = render

export default script